//GTAFunGetFace算法对应的显示
//  根据返回的数据通过html展示出来
export function showFaceApiDom(self, result, partIndex) {
  var html1 = ''
  Jquery('div').remove('.italic')
  if (result != null) {
    var face_list = result['face_list']
    for (var i = 0; i < face_list.length; i++) {
      if (face_list.length == 2) {
        // console.log(111);
      }
      var top = face_list[i]['location']['top'] + self.MediaOffsetTop
      var left = face_list[i]['location']['left'] + self.MediaOffsetLeft
      var tranX = eval(face_list[i]['location']['width'] + 55)
      var tranY = 0
      var italicHeight = eval(face_list[i]['location']['height'])
      if (italicHeight < 46) {
        tranY = italicHeight - 46 - italicHeight / 2
      }
      var tranXl = eval(-55 - 180)
      var placel =
        left + face_list[i]['location']['width'] + 55 + 180 - self.mediaWidth <
        0
          ? true
          : false
      tranX = placel ? tranX : tranXl
      var aiScan = placel ? 'ai-scan' : 'ai-scanl'
      html1 +=
        "<div class='italic' style='position:absolute; top:" +
        top +
        'px; left:' +
        left +
        'px; border-style:solid;border-width:2px;border-color:#6D9AEE;filter:alpha(opacity=90);width:' +
        face_list[i]['location']['width'] +
        'px;height: ' +
        face_list[i]['location']['height'] +
        "px;z-index:999;background-color:rgba(104, 152, 240, 0.3);'>"
      // 文本内容
      //测试测试测试
      html1 +=
        "<div class='" +
        aiScan +
        "' style='transform: translate(" +
        tranX +
        'px, ' +
        tranY +
        "px);'>"
      html1 +=
        "<p style='display:" +
        (showBlock('age', partIndex) ? ' block' : 'none') + //控制积木功能是否显示
        "' >年龄：" +
        face_list[i]['age'] +
        '</p>'
      html1 +=
        "<p style='display:" +
        (showBlock('beauty', partIndex) ? ' block' : 'none') + //控制积木功能是否显示
        "' >颜值：" +
        face_list[i]['beauty'] +
        '</p>'
      html1 +=
        "<p style='display:" +
        (showBlock('expression', partIndex) ? ' block' : 'none') + //控制积木功能是否显示
        "'>表情：" +
        face_list[i]['expression']['type'] +
        '</p>'
      html1 +=
        "<p style='display:" +
        (showBlock('faceShape', partIndex) ? ' block' : 'none') + //控制积木功能是否显示
        "'>脸型：" +
        face_list[i]['face_shape']['type'] +
        '</p>'
      html1 +=
        "<p style='display:" +
        (showBlock('race', partIndex) ? ' block' : 'none') + //控制积木功能是否显示
        "'>人种：" +
        face_list[i]['race']['type'] +
        '</p>'
      html1 +=
        "<p style='display:" +
        (showBlock('emotion', partIndex) ? ' block' : 'none') + //控制积木功能是否显示
        "'>情绪：" +
        face_list[i]['emotion']['type'] +
        '</p>'
      html1 +=
        "<p style='display:" +
        (showBlock('gender', partIndex) ? ' block' : 'none') + //控制积木功能是否显示
        "'>性别：" +
        face_list[i]['gender']['type'] +
        '</p>'
      html1 += '</div>'
      html1 +=
        "<div style='position:absolute;left:-10px;top:-10px;margin:10px;width:100%;height:100%;'>" +
        "<span style='position:absolute;padding:8px;border-style: solid;border-color: #6D9AEE;border-width: 5px 0 0 5px;top:-3px;left:-3px;'>" +
        '</span>'
      html1 +=
        "<span style='position:absolute;padding:8px;border-style: solid;border-color: #6D9AEE;border-width: 5px 5px 0 0;top:-3px;right:-3px;'>" +
        '</span>'
      html1 +=
        "<span style='position:absolute;padding:8px;border-style: solid;border-color: #6D9AEE;border-width: 0 0 5px 5px;bottom:-3px;left:-3px;'>" +
        '</span>'
      html1 +=
        "<span style='position:absolute;padding:8px;border-style: solid;border-color: #6D9AEE;border-width: 0 5px 5px 0;bottom:-3px;right:-3px;'>" +
        '</span>'
      html1 += '</div>'
      html1 += '</div>'
    }
    Jquery('#divvideo1').append(html1)
  }
}
// GTAFunGetHand算法对应的显示
export function showHandApiDom(self, data, partIndex) {
  //方法中传入的参数data为后台获取的数据
  var html1 = ''
  var face_num = 0 //人流数
  if (!data) {
    return
  }
  if (data.length > 0) {
    var _list = data
    Jquery('div').remove('.italic1')
    for (var i = 0; i < _list.length; i++) {
      if (_list[i]['classname'] != 'Face') {
        // debugger;
        //框住手势，给与标识与置信度显示
        var top = _list[i]['top'] + self.MediaOffsetTop
        var left = _list[i]['left'] + self.MediaOffsetLeft
        var tranX = eval(_list[i]['width'] + 55)
        var tranY = 0
        var italicHeight = eval(_list[i]['height'])
        if (italicHeight < 46) {
          tranY = italicHeight - 46 - italicHeight / 2
        }
        var tranXl = eval(-55 - 180)
        var placel =
          left + _list[i]['width'] + 55 + 180 - self.mediaWidth < 0
            ? true
            : false
        tranX = placel ? tranX : tranXl
        var aiScan = placel ? 'ai-scan' : 'ai-scanl'
        self.showHandBlock(_list[i]['classname'], partIndex)
        html1 +=
          "<div class='italic1' style='position:absolute; top:" +
          top +
          'px; left:' +
          left +
          'px; border-style:solid;border-width:2px;border-color:#6D9AEE;filter:alpha(opacity=90);width:' +
          _list[i]['width'] +
          'px;height: ' +
          _list[i]['height'] +
          "px;background-color:rgba(104, 152, 240, 0.3);'>"
        html1 +=
          "<p class='" +
          aiScan +
          "' style='font-size:8px;color:red;transform: translate(" +
          tranX +
          'px, ' +
          tranY +
          "px);'>手势：" +
          // _list[i]["classname"] +
          self.partNumArr[partIndex - 1].aiHandBlockText
        ;('</p>')
        html1 +=
          "<p class='" +
          aiScan +
          "'" +
          " style='font-size:8px;color:red;display:" +
          (_list[i]['classname'] ? ' block' : 'none') +
          ' transform: translate(' +
          tranX +
          'px, ' +
          tranY +
          "px);'>置信度：" +
          _list[i]['probability'].toFixed(3) +
          '</p>'
        html1 +=
          "<div style='position:absolute;left:-10px;top:-10px;margin:10px;width:100%;height:100%;'>" +
          "<span style='position:absolute;padding:8px;border-style: solid;border-color: #6D9AEE;border-width: 5px 0 0 5px;top:-3px;left:-3px;'>" +
          '</span>'
        html1 +=
          "<span style='position:absolute;padding:8px;border-style: solid;border-color: #6D9AEE;border-width: 5px 5px 0 0;top:-3px;right:-3px;'>" +
          '</span>'
        html1 +=
          "<span style='position:absolute;padding:8px;border-style: solid;border-color: #6D9AEE;border-width: 0 0 5px 5px;bottom:-3px;left:-3px;'>" +
          '</span>'
        html1 +=
          "<span style='position:absolute;padding:8px;border-style: solid;border-color: #6D9AEE;border-width: 0 5px 5px 0;bottom:-3px;right:-3px;'>" +
          '</span>'
        html1 += '</div>'
        html1 += '</div>'
      } else {
        face_num += 1
      }
    }
    Jquery('#divvideo1').append(html1)
  }
}

//对应GTAFunGetBody算法 getBodyApi人体检测返回的数据通过html展示出来
export function showBodyApiDom(self, data, partIndex) {
  var html1 = ''
  Jquery('span.body-point').remove()
  Jquery('div').remove('.italic2')
  if (data.person_num > 0) {
    // if (data.person_num > 0) {
    var _list = data['person_info']
    for (var i = 0; i < _list.length; i++) {
      //人体关键点标记
      html1 +=
        "<span class='body-point' style='position: absolute; top: " +
        _list[i]['body_parts']['left_ankle']['y'] +
        self.MediaOffsetTop +
        'px; left: ' +
        _list[i]['body_parts']['left_ankle']['x'] +
        "px; color: #2081fc; font - size: 8px;'>●</span>"
      html1 +=
        "<span class='body-point' style='position: absolute; top: " +
        _list[i]['body_parts']['left_hip']['y'] +
        self.MediaOffsetTop +
        'px; left: ' +
        _list[i]['body_parts']['left_hip']['x'] +
        "px; color: #2081fc; font - size: 8px;'>●</span>"
      html1 +=
        "<span class='body-point' style='position: absolute; top: " +
        _list[i]['body_parts']['top_head']['y'] +
        self.MediaOffsetTop +
        'px; left: ' +
        _list[i]['body_parts']['top_head']['x'] +
        "px; color: #2081fc; font - size: 8px;'>●</span>"
      html1 +=
        "<span class='body-point' style='position: absolute; top: " +
        _list[i]['body_parts']['right_mouth_corner']['y'] +
        self.MediaOffsetTop +
        'px; left: ' +
        _list[i]['body_parts']['right_mouth_corner']['x'] +
        "px; color: #2081fc; font - size: 8px;'>●</span>"
      html1 +=
        "<span class='body-point' style='position: absolute; top: " +
        _list[i]['body_parts']['neck']['y'] +
        self.MediaOffsetTop +
        'px; left: ' +
        _list[i]['body_parts']['neck']['x'] +
        "px; color: #2081fc; font - size: 8px;'>●</span>"
      html1 +=
        "<span class='body-point' style='position: absolute; top: " +
        _list[i]['body_parts']['left_shoulder']['y'] +
        self.MediaOffsetTop +
        'px; left: ' +
        _list[i]['body_parts']['left_shoulder']['x'] +
        "px; color: #2081fc; font - size: 8px;'>●</span>"
      html1 +=
        "<span class='body-point' style='position: absolute; top: " +
        _list[i]['body_parts']['left_mouth_corner']['y'] +
        self.MediaOffsetTop +
        'px; left: ' +
        _list[i]['body_parts']['left_mouth_corner']['x'] +
        "px; color: #2081fc; font - size: 8px;'>●</span>"
      html1 +=
        "<span class='body-point' style='position: absolute; top: " +
        _list[i]['body_parts']['left_knee']['y'] +
        self.MediaOffsetTop +
        'px; left: ' +
        _list[i]['body_parts']['left_knee']['x'] +
        "px; color: #2081fc; font - size: 8px;'>●</span>"
      html1 +=
        "<span class='body-point' style='position: absolute; top: " +
        _list[i]['body_parts']['right_elbow']['y'] +
        self.MediaOffsetTop +
        'px; left: ' +
        _list[i]['body_parts']['right_elbow']['x'] +
        "px; color: #2081fc; font - size: 8px;'>●</span>"
      html1 +=
        "<span class='body-point' style='position: absolute; top: " +
        _list[i]['body_parts']['right_ear']['y'] +
        self.MediaOffsetTop +
        'px; left: ' +
        _list[i]['body_parts']['right_ear']['x'] +
        "px; color: #2081fc; font - size: 8px;'>●</span>"
      html1 +=
        "<span class='body-point' style='position: absolute; top: " +
        _list[i]['body_parts']['nose']['y'] +
        self.MediaOffsetTop +
        'px; left: ' +
        _list[i]['body_parts']['nose']['x'] +
        "px; color: #2081fc; font - size: 8px;'>●</span>"
      html1 +=
        "<span class='body-point' style='position: absolute; top: " +
        _list[i]['body_parts']['left_eye']['y'] +
        self.MediaOffsetTop +
        'px; left: ' +
        _list[i]['body_parts']['left_eye']['x'] +
        "px; color: #2081fc; font - size: 8px;'>●</span>"
      html1 +=
        "<span class='body-point' style='position: absolute; top: " +
        _list[i]['body_parts']['right_eye']['y'] +
        self.MediaOffsetTop +
        'px; left: ' +
        _list[i]['body_parts']['right_eye']['x'] +
        "px; color: #2081fc; font - size: 8px;'>●</span>"
      html1 +=
        "<span class='body-point' style='position: absolute; top: " +
        _list[i]['body_parts']['right_hip']['y'] +
        self.MediaOffsetTop +
        'px; left: ' +
        _list[i]['body_parts']['right_hip']['x'] +
        "px; color: #2081fc; font - size: 8px;'>●</span>"
      html1 +=
        "<span class='body-point' style='position: absolute; top: " +
        _list[i]['body_parts']['left_wrist']['y'] +
        self.MediaOffsetTop +
        'px; left: ' +
        _list[i]['body_parts']['left_wrist']['x'] +
        "px; color: #2081fc; font - size: 8px;'>●</span>"
      html1 +=
        "<span class='body-point' style='position: absolute; top: " +
        _list[i]['body_parts']['left_ear']['y'] +
        self.MediaOffsetTop +
        'px; left: ' +
        _list[i]['body_parts']['left_ear']['x'] +
        "px; color: #2081fc; font - size: 8px;'>●</span>"
      html1 +=
        "<span class='body-point' style='position: absolute; top: " +
        _list[i]['body_parts']['left_elbow']['y'] +
        self.MediaOffsetTop +
        'px; left: ' +
        _list[i]['body_parts']['left_elbow']['x'] +
        "px; color: #2081fc; font - size: 8px;'>●</span>"
      html1 +=
        "<span class='body-point' style='position: absolute; top: " +
        _list[i]['body_parts']['right_shoulder']['y'] +
        self.MediaOffsetTop +
        'px; left: ' +
        _list[i]['body_parts']['right_shoulder']['x'] +
        "px; color: #2081fc; font - size: 8px;'>●</span>"
      html1 +=
        "<span class='body-point' style='position: absolute; top: " +
        _list[i]['body_parts']['right_ankle']['y'] +
        self.MediaOffsetTop +
        'px; left: ' +
        _list[i]['body_parts']['right_ankle']['x'] +
        "px; color: #2081fc; font - size: 8px;'>●</span>"
      html1 +=
        "<span class='body-point' style='position: absolute; top: " +
        _list[i]['body_parts']['right_knee']['y'] +
        self.MediaOffsetTop +
        'px; left: ' +
        _list[i]['body_parts']['right_knee']['x'] +
        "px; color: #2081fc; font - size: 8px;'>●</span>"
      html1 +=
        "<span class='body-point' style='position: absolute; top: " +
        _list[i]['body_parts']['right_wrist']['y'] +
        self.MediaOffsetTop +
        'px; left: ' +
        _list[i]['body_parts']['right_wrist']['x'] +
        "px; color: #2081fc; font - size: 8px;'>●</span>"
      //人体检测框图
      var top = _list[i]['location']['top'] + self.MediaOffsetTop //
      var left = _list[i]['location']['left'] + self.MediaOffsetLeft
      var tranX = eval(_list[i]['location']['width'] + 55)
      var tranY = 0
      var italicHeight = eval(_list[i]['location']['height'])
      if (italicHeight < 46) {
        tranY = italicHeight - 46 - italicHeight / 2
      }

      var tranXl = eval(-55 - 180)
      var placel =
        left + _list[i]['location']['width'] + 55 + 180 - self.mediaWidth < 0
          ? true
          : false
      tranX = placel ? tranX : tranXl
      var aiScan = placel ? 'ai-scan' : 'ai-scanl'
      // console.log("_list[i]222" + _list[i]["location"]["top"]);
      html1 +=
        "<div class='italic2' style='position:absolute; top:" +
        top +
        'px; left:' +
        left +
        'px; border-style:solid;border-width:2px;border-color:#6D9AEE;filter:alpha(opacity=90);width:' +
        _list[i]['location']['width'] +
        'px;height: ' +
        _list[i]['location']['height'] +
        "px; background-color:rgba(104, 152, 240, 0.3);'>"
      html1 +=
        "<p   class='" +
        aiScan +
        "' style='display:" +
        (self.showBlock('score', partIndex) ? ' block' : 'block') +
        ';transform: translate(' +
        tranX +
        'px, ' +
        tranY +
        "px);'>置信度：" +
        _list[i]['location']['score'].toFixed(3) +
        '</p>'
      html1 +=
        "<div style='position:absolute;left:-10px;top:-10px;margin:10px;width:100%;height:100%;'>" +
        "<span style='position:absolute;padding:8px;border-style: solid;border-color: #6D9AEE;border-width: 5px 0 0 5px;top:-3px;left:-3px;'>" +
        '</span>'
      html1 +=
        "<span style='position:absolute;padding:8px;border-style: solid;border-color: #6D9AEE;border-width: 5px 5px 0 0;top:-3px;right:-3px;'>" +
        '</span>'
      html1 +=
        "<span style='position:absolute;padding:8px;border-style: solid;border-color: #6D9AEE;border-width: 0 0 5px 5px;bottom:-3px;left:-3px;'>" +
        '</span>'
      html1 +=
        "<span style='position:absolute;padding:8px;border-style: solid;border-color: #6D9AEE;border-width: 0 5px 5px 0;bottom:-3px;right:-3px;'>" +
        '</span>'
      html1 += '</div>'
      html1 += '</div>'
    }
    Jquery('#divvideo1').append(html1)
  }
}

function showBlock(type, index) {}
